import { BaseController, Rx, type SubtreeModel } from "subtree.js/core";

export class ViewerPreviewState {
  /** The label pool, folded by default: three hundred names must not push the grid off the screen. */
  readonly poolOpen = new Rx(false);
}

export abstract class ViewerPreviewActions {
  abstract togglePool(): void;
}

/** The stream as a buyer has it, on the host's own screen. Everything shown is the cockpit's own state; this only folds the pool. */
export class ViewerPreviewController extends BaseController implements ViewerPreviewActions {
  readonly state = new ViewerPreviewState();

  constructor(subtree: SubtreeModel) {
    super();
    subtree.put(ViewerPreviewState, this.state);
    subtree.put(ViewerPreviewActions, this);
  }

  togglePool = () => {
    this.state.poolOpen.update((open) => !open);
  };
}
